import { z } from 'zod'

export const PartyCreateSchema = z.object({
  code: z.string(),
  name: z.string(),
  isSupplier: z.boolean(),
  isCustomer: z.boolean(),
})

export type PartyCreateModel = z.infer<typeof PartyCreateSchema>

export const PartyUpdateSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  isSupplier: z.boolean(),
  isCustomer: z.boolean(),
})

export type PartyUpdateModel = z.infer<typeof PartyUpdateSchema>
